export const t = { "en": { "marketplace-embed-ba": { "cta": { "open": "Open" } } } };
export const d = [require("marketplace-ui-install/lang/en.lyaml"),require("marketplace-embed/lang/en.lyaml")];